// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/6/6
// +-------------------------------------------------------------
// |Time: 12:13
// +-------------------------------------------------------------
import request from "@/utils/request";

export const getProfile = (data) =>
    request({
        url: '/user/info',
        method: 'get',
        params:data,
    })
export const certification = (data) =>
    request({
        url: '/user/certification',
        method: 'post',
        data,
    })